import { render } from "./review-rating-stars.vue?vue&type=template&id=020b2b24&scoped=true"
import script from "./review-rating-stars.vue?vue&type=script&lang=js"
export * from "./review-rating-stars.vue?vue&type=script&lang=js"

import "./review-rating-stars.vue?vue&type=style&index=0&id=020b2b24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020b2b24"]])

export default __exports__